import AppRouter from './AppRouter';
import { appUrls } from './constants';

export { appUrls };
export default AppRouter;
